<template>
  <div class="xl:h-full xl:min-h-full flex flex-row xl:flex-wrap flex-wrap flex-grow xl:overflow-scroll" @scroll.passive="handleScroll">
    <div
      class="w-1/5 hidden xl:block self-stretch relative border-r-2 border-gray-200"
    >
      <LeftSidebar />
    </div>
    <Header class="xl:hidden flex justify-between w-full xl:px-14 lg:px-20 sm:px-14 px-5" />
    <div class="xl:w-4/5 w-full xl:self-stretch">
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import LeftSidebar from "@/components/common/LeftSidebar";
import Header from "@/components/common/Header";

import { mapGetters, mapMutations } from "vuex";
export default {
  components: {
    Header,
    LeftSidebar,
  },
  data() {
    return {
      items: [
        {
          title: "Home",
          icon: "folder-open-o",
          to: "/",
          toggle: false,
          child: [],
        },
        {
          title: "Introduction",
          icon: "folder-open-o",
          child: [
            {
              label: "API",
              to: "/introduction/API",
            },
          ],
          toggle: false,
        },
        {
          title: "Client",
          icon: "folder-open-o",
          toggle: false,
          child: [
            {
              label: "API",
              to: "/client/API",
            },
            {
              label: "SDK",
              to: "/client/SDK",
            },
          ],
        },
        {
          title: "Merchant",
          icon: "folder-open-o",
          toggle: false,
          child: [
            {
              label: "API",
              to: "/merchant/API",
            },
            {
              label: "SFTP",
              to: "/merchant/SFTP",
            },
          ],
        },
      ],
      links: [
        {
          name: "Home",
          to: "/",
        },
        {
          name: "Merchant",
          to: "/merchant",
        },
        {
          name: "Client",
          to: "/client",
        },
        {
          name: "About",
          to: "/about",
        },
      ],
      activeMenu: false,
    };
  },
  computed: {
    ...mapGetters("common", ["isPanelOpen"]),
  },
  methods: {
    ...mapMutations("common", ["setOffset"]),
    handleScroll(event) {
      if(event.target.scrollTop > 150)
        this.setOffset(true);
      else if (event.target.scrollTop < 150)
        this.setOffset(false);
    },
  }
};
</script>
